angular.module('app.directives.checkout').directive('checkoutShippingAddress', () => {
  return {
    restrict: 'E',
    scope: {
      vm: '=',
    },
    template: `
<div style="margin:15px 0;">
  <input ng-model="vm.shippingSameAsBilling"
          ng-init="vm.shippingSameAsBilling = true"
          type="checkbox"
          name="shipping_same_as_billing">
    Shipping address is same as billing.
</div>
<div ng-if="!vm.shippingSameAsBilling">
  <div class="form-group">
    <label for="address" class="control-label">Street Address</label>
    <input ng-model="vm.shipping.address" id="bill_address" name="address" type="text" class="form-control" autocomplete="address" placeholder="" required>
  </div>
  <div class="row">
    <div class="col-xs-6">
      <div class="form-group">
        <label for="city" class="control-label">City</label>
        <input ng-model="vm.shipping.city" id="city" name="city" type="text" class="form-control" autocomplete="city" placeholder="" required>
      </div>
    </div>
    <div class="col-xs-6">
      <div class="form-group">
        <label for="state" class="control-label">State/Region</label>
        <input ng-if="vm.shipping.country != 'US'"
                ng-model="vm.shipping.state" id="state" name="state" type="text" class="form-control" autocomplete="state" placeholder="" required>
        <select ng-if="vm.shipping.country == 'US'"
                ng-model="vm.shipping.state"
                ng-options="c.code as c.name for c in vm.states"
                id="state" name="state" class="form-control" required>
        </select>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-xs-6">
      <div class="form-group">
        <label for="zip" class="control-label">Postal Code</label>
        <input ng-model="vm.shipping.postal_code" id="zip" name="zip" type="text" class="form-control" autocomplete="zip" placeholder="" required>
      </div>
    </div>
    <div class="col-xs-6">
      <div class="form-group">
        <label for="country" class="control-label">Country</label>
        <select ng-model="vm.shipping.country"
                ng-init="vm.shipping.country = vm.shipping.country || 'US'"
                ng-options="c.code as c.name for c in vm.countries"
                id="country" name="country" class="form-control" required>
        </select>
      </div>
    </div>
  </div>
</div>
      `,
  };
});



// WEBPACK FOOTER //
// ./app/directives/checkout/checkout-shipping-address.js